// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// Explicit component imports (tree-shakeable) instead of `import * as
// components` — the wildcard shipped every Vuetify component in the bundle.
// The list is the union of all <v-*> tags used in src/**/*.vue.
// Entries this nightly build doesn't export arrive as undefined and are
// filtered out below — identical behavior to before, where those tags were
// unresolved anyway. No Vuetify directives are used in any template.
import {
  VApp,
  VAppBar,
  VMain,
  VFooter,
  VContainer,
  VRow,
  VCol,
  VSpacer,
  VBtn,
  VBtnToggle,
  VIcon,
  VImg,
  VCard,
  VCardText,
  VCardTitle,
  VCardSubtitle,
  VCardActions,
  VChip,
  VChipGroup,
  VList,
  VListItem,
  VListItemTitle,
  VListItemSubtitle,
  VListItemIcon,
  VListItemAction,
  VAlert,
  VTextarea,
  VTextField,
  VSelect,
  VSwitch,
  VMenu,
  VDialog,
  VDivider,
  VTable,
  VTabs,
  VTab,
  VSnackbar,
  VProgressLinear,
  VExpansionPanels,
  VExpansionPanel,
  VExpansionPanelTitle,
  VExpansionPanelText,
  VExpandTransition,
} from 'vuetify/components'

const candidates = {
  VApp,
  VAppBar,
  VMain,
  VFooter,
  VContainer,
  VRow,
  VCol,
  VSpacer,
  VBtn,
  VBtnToggle,
  VIcon,
  VImg,
  VCard,
  VCardText,
  VCardTitle,
  VCardSubtitle,
  VCardActions,
  VChip,
  VChipGroup,
  VList,
  VListItem,
  VListItemTitle,
  VListItemSubtitle,
  VListItemIcon,
  VListItemAction,
  VAlert,
  VTextarea,
  VTextField,
  VSelect,
  VSwitch,
  VMenu,
  VDialog,
  VDivider,
  VTable,
  VTabs,
  VTab,
  VSnackbar,
  VProgressLinear,
  VExpansionPanels,
  VExpansionPanel,
  VExpansionPanelTitle,
  VExpansionPanelText,
  VExpandTransition,
}

const components = Object.fromEntries(
  Object.entries(candidates).filter(([, component]) => component)
)

const myCustomLightTheme = {
  dark: false,
  colors: {
    info: '#0a1726',
    primary: '#35b000'
  }
}

export default createVuetify({
  components,
  theme: {
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme,
    }
  }
});
